export enum PartyType {
  PERSON = 'person',
  ORGANIZATION = 'organization'
}

export enum PartyRole {
  BUYER = 'buyer',
  DEVELOPER = 'developer',
  SELLER = 'seller',
  OPTION_HOLDER = 'option_holder',
  BENEFICIARY = 'beneficiary',
  SUPPLIER = 'supplier',
  TRUSTEE = 'trustee'
}

export enum IdentityDocumentType {
  NATIONAL_ID = 'national_id',
  PASSPORT = 'passport'
}
